import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {LoginComponent} from "./login/login.component";
import {VinsComponent} from "./vins/vins.component";
import {CommandsComponent} from "./commands/commands.component";
import {ManageVehiclesComponent} from "./manage-vehicles/manage-vehicles.component";
import {LoginGuardService} from "./authentication/login-guard.service";
import {MessageCenterComponent} from "./message-center/message-center.component";
import {NotFoundComponent} from '@wame/ngx-frf-utilities';
import {MsalGuard} from "@azure/msal-angular";
import {LoginFailedComponent} from "./login-failed/login-failed.component";
import {LogoutComponent} from "./logout/logout.component";

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'vins',
    component: VinsComponent,
    canActivate: [MsalGuard, LoginGuardService]
  },
  {
    path: 'commands',
    component: CommandsComponent,
    canActivate: [MsalGuard, LoginGuardService]
  },
  {
    path: 'manage-vehicles',
    component: ManageVehiclesComponent,
    canActivate: [MsalGuard, LoginGuardService]
  },
  {
    path: '',
    component: VinsComponent,
    canActivate: [MsalGuard, LoginGuardService]
  },
  {
    path: 'message-center',
    component: MessageCenterComponent,
    canActivate: [MsalGuard, LoginGuardService]
  },
  {
    path: 'login-failed',
    component: LoginFailedComponent
  },
  {
    path: 'logout',
    component: LogoutComponent
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
